import React from 'react';
import { isStandardSize, Size } from '../../constants/sizes.constants';
import './Spacer.scss';

type SpacerProps = {
  size?: Size | string | number,
  inline?: boolean,
}

const Spacer: React.FC<SpacerProps> = props => {
  const { size = '1em' } = props;
  const isCustomValue = typeof props.size === 'number' || !isStandardSize(size);
  const style = {
    display: props.inline ? 'inline-block' : undefined,
    width: isCustomValue ? size : undefined,
    height: isCustomValue ? size : undefined,
  }
  return <div className="Spacer" data-size={props.size} style={style} />
}

export default Spacer;